// extracted by mini-css-extract-plugin
export default {"search":"PlainInputSearch_search__aysPk","clearSearch":"PlainInputSearch_clearSearch__Mhkth","placeHolderShimmer":"PlainInputSearch_placeHolderShimmer__VtlG5"};